{
    "PaginatedList_Search": "Pesquisar",
    "PaginatedList_Search_NoResults": "Não foram encontradas extensões correspondentes a essa pesquisa",
    "NAME": "PaginatedList"
}